import { combineReducers } from 'redux'

import alerts from './alerts'
import articles from './articles'
import auth from './auth'
import faqs from './faqs'
import icons from './icons'
import ideas from './ideas'
import preregister from './pre-register'
import tags from './tags'
import users from './users'
import leaderboards from './leaderboards'
import kpis from './kpis'

const appReducers = () =>
    combineReducers({
        alerts,
        articles,
        auth,
        faqs,
        icons,
        ideas,
        kpis,
        leaderboards,
        preregister,
        tags,
        users,
    })

export default appReducers
